<template>
  <div>
    <!-- 기본정보 -->
    <field-select-module v-model="form.stdInfo" :board="board" :is-print="isPrint" />

    <!-- 구분 -->
    <write-grid-container title="구분" v-model="form.구분" :options="gridContainerOptions" class="sub mt-7">
      <template slot-scope="{ index, label, value, dataType }">
        <div v-if="isPrint" class="printing">
          <date-selector-rang v-if="dataType === 'daterang'" v-model="form.구분[value]" is-print />
          <div v-else class="print-input">{{ form.구분[value] }}</div>
        </div>

        <div v-else class="write-grid-container-col">
          <CompanySelector v-if="dataType === 'company'" v-model="form.구분[value]" :company-name="form.업체명.com_name" @select="(data) => (form.업체명 = data)" :readonly="board.readonly"></CompanySelector>
          <date-selector-rang v-else-if="dataType === 'daterang'" v-model="form.구분[value]" readonly />
          <NumberInput v-else-if="dataType === 'number'" v-model="form.구분[value]" class="w-full" readonly />
          <ml-input v-else :readonly="board.readonly" v-model="form.구분[value]" visible-counter />
        </div>
      </template>
    </write-grid-container>

    <!-- 사내 수급업체 수행평가표 -->
    <table-evaluation
      :readonly="board.readonly"
      labelHead="평가항목"
      scoreHead="평가점수"
      labelFooter="총계"
      useSectionScore
      :is-print="isPrint"
      class="mt-5"
      title="사내 수급업체 수행평가표"
      :partReadonly="this.openType === 'popup'"
      v-model="form.evaluationList"
      @userScore="userScore"
    />

    <!-- 파일첨부 -->
    <file-upload-module id="fileList" class="w-full mt-4" v-model="form.fileList" :is-print="isPrint" :readonly="board.readonly"></file-upload-module>
  </div>
</template>

<script>
import FileUploadModule from "@/views/modules/FileUploadModule";
import FieldSelectModule from "@/views/modules/FieldSelectModule";
import WriteGridContainer from "@/components/WriteGridContainer.vue";
import DateSelector from "@/components/selector/DateSelector.vue";

import CompanySelector from "@/components/selector/CompanySelector";
import TableEvaluation from "@/components/TableEvaluation";
import DateSelectorRang from "@/components/selector/DateSelectorRang.vue";
import NumberInput from "@/components/NumberInput.vue";

export default {
  components: {
    NumberInput,
    DateSelectorRang,
    DateSelector,
    WriteGridContainer,
    FieldSelectModule,
    FileUploadModule,

    CompanySelector,
    TableEvaluation,
  },
  props: {
    isPrint: Boolean,
    board: Object,
    value: Object,
    openType: String,
  },
  computed: {
    evaluationTable() {
      return [
        {
          id: 1,
          label: "서류평가",
          childs: [
            {
              label: "리더십",
              max: 10,
              value: 0,
            },
            {
              label: "근로자참여",
              max: 10,
              value: 0,
            },
            {
              label: "위험요인 파악 및 제거·대체·통제",
              max: 10,
              value: 0,
            },
            {
              label: "비상조치계획",
              max: 10,
              value: 0,
            },
          ],
        },
        {
          id: 2,
          label: "현장평가",
          partReadonly: true,
          childs: [
            {
              label: "복장 및 보호구",
              max: 5,
              value: 0,
            },
            {
              label: "위험기계 기구 상태",
              max: 10,
              value: 0,
            },
            {
              label: "화재예방, 표지판 설치",
              max: 10,
              value: 0,
            },
            {
              label: "안전관리",
              max: 10,
              value: 0,
            },
            {
              label: "안전미팅",
              max: 5,
              value: 0,
            },
            {
              label: "환경관리",
              max: 5,
              value: 0,
            },
            {
              label: "기초질서 등",
              max: 15,
              value: 0,
            },
          ],
        },
      ];
    },
    postId() {
      return parseInt(this.$route.params.postId);
    },
  },
  data() {
    return {
      form: {
        stdInfo: {},

        구분: {},
        업체명: {},

        evaluationList: [],
        userScore: 0,

        fileList: [],
      },
      gridContainerOptions: {
        dataTypes: ["company", "string", "daterang", "number"], // 2025-03-26, 이정민, 허가번호는 제거
        labels: ["업체명", "공사명", "작업기간", "공사금액"],
        values: ["업체명", "공사명", "작업기간", "공사금액"],
      },
    };
  },
  watch: {
    value: {
      immediate: true,
      deep: true,
      handler(value) {
        const keys = Object.keys(this.form);
        for (const key of keys) {
          if (value[key]) {
            this.form[key] = value[key];
          }
        }

        if (!this.form || !this.form.evaluationList || this.form.evaluationList.length === 0) {
          this.form.evaluationList = this.evaluationTable;
        }
      },
    },
    form: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
  },
  created() {
    // 구분 초기화
    this.form.구분 = this.gridContainerOptions.values.reduce((acc, cur) => {
      acc[cur] = "";
      return acc;
    }, {});

    const keys = Object.keys(this.form);
    for (const key of keys) {
      if (this.value[key]) {
        this.form[key] = this.value[key];
      }
    }
  },
  mounted() {
    const popupboardContainer = document.getElementById("Popupboard-Container");
    if (popupboardContainer) document.body.insertBefore(popupboardContainer, document.body.firstChild);
    this.$emit("saveButtonControl", !!this.postId);
  },
  methods: {
    userScore(value) {
      this.form.userScore = value;
    },
  },
};
</script>

<style scoped lang="scss"></style>
